// app/features/ai-workflows/components/workflows/PersonalizedUseCaseBaseCardComponent.tsx
'use client';
export type { BaseCardComponentProps as PersonalizedUseCaseBaseCardComponentProps } from '@/app/shared/components/workflow-renderer/BaseCardComponent';
export { BaseCardComponent as PersonalizedUseCaseBaseCardComponent } from '@/app/shared/components/workflow-renderer/BaseCardComponent';
export { COMPONENT_TYPE_STYLES } from '@/app/shared/components/workflow-renderer/BaseCardComponent';
